<template>
  <div class="disclaimer">
    <Retailnavbar> </Retailnavbar>

    <div class="main-page">
      <div class="section-1">Legal Disclaimer</div>

     <DisclaimerComponent></DisclaimerComponent>
    </div>

     <RetailFooter></RetailFooter>
  </div>
</template>
<script>
import { screenSize } from "../../mixins/ScreenSize.js";
// import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import Retailnavbar from "@/components/RetailSideCompo/RetailNavbar.vue";
import DisclaimerComponent from "@/components/RetailSideCompo/DisclaimerComponent.vue";

export default {
  name: "BrokersPrivacyPolicy",

  components: {DisclaimerComponent, RetailFooter, Retailnavbar },

  mixins: [screenSize],

  data() {
    return {
      // search_stock: "",
      // value2: 4,
      // colors: ["#99A9BF", "#F7BA2A", "#ffff"],
      // selectedCard: "marketSentiment",
      // marketSentimentData: [
      //   {
      //     heading: "",
      //   },
      // ],
    };
  },

  methods: {},

  computed: {},
};
</script>
<style lang="scss" scoped>
.disclaimer {
  background-color: #fcfcfb;
  .main-page {
    .section-1 {
      background-image: url("../../assets/images/ExpertLandingPage/footer/broker/banner image.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 400px;
      font-size: 2rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #000;
      text-align: center;
      padding-top: 150px;
    }
    

    @media screen and (max-width: 876px) {
      .section-1 {
        height: 346px;
        font-size: 1.5rem;
      }
    }
    @media screen and (max-width: 600px) {
      .section-1 {
        height: 200px;
        padding-top: 80px;
        font-size: 1.2rem;
      }
    }
    @media screen and (max-width: 450px) {
      .section-1 {
        height: 134px;
      }
    }
  }
}
</style>


